export default __webpack_public_path__ + "static/media/eye-close.25e9b13a.svg";